import React from "react";
import { withStyles } from "@mui/styles";
import { Link } from "react-router-dom";
// import { KeyboardArrowDown } from '@mui/icons-material';
import logo from "../../assets/isologo-white.svg";
import collapsedLogo from "../../assets/iso-white.svg";
// import whiteLogo from "../../assets/iso-white.svg";
const styles = (theme) => ({
  logo: {
    height: "30px",
    marginBottom: 0,
  },
});
const Logo = (props) => {
  const { classes, collapsed = false } = props;
  let src = collapsed ? collapsedLogo : logo;
  return (
    <Link to="/" style={{ display: "flex" }}>
      <img src={src} className={classes.logo} alt="logo" />
    </Link>
  );
};

export default withStyles(styles)(Logo);
